





















































































import Vue from "vue";
import Component from "vue-class-component";
import { targets, maps, features } from "@/store";
import { MutationTypes } from "@/store/mutations-types";

@Component
export default class ToolsMenu extends Vue {
  get predictionTargetTime() {
    return targets.getters.predictionTime;
  }
  set predictionTargetTime(val) {
    targets.commit(MutationTypes.SET_PREDICTION_TIME, val);
  }

  get targetsTags() {
    return targets.getters.targetsTagsEnabled;
  }
  set targetsTags(val) {
    targets.commit(MutationTypes.CHANGE_TARGETS_TAG, val);
  }

  get platformTags() {
    return features.getters.platformTagEnabled;
  }
  set platformTags(val) {
    features.commit(MutationTypes.CHANGE_PLATFORM_TAG, val);
  }

  get targetsZoom() {
    return maps.getters.targetsTagsZoom;
  }
  set targetsZoom(val) {
    maps.commit(MutationTypes.SET_TARGETS_TAG_ZOOM, val);
  }

  get platformsZoom() {
    return maps.getters.platformsTagsZoom;
  }
  set platformsZoom(val) {
    maps.commit(MutationTypes.SET_PLATFORMS_TAG_ZOOM, val);
  }
}
